module.exports = __webpack_public_path__ + "img/top-logo.7d5709f1.png";